import { TimerFavorite } from 'src/models/timer';

import { Callback } from 'src/util/query/models/Callback';

import { SetTimerFavoritesPayload } from '../interfaces';

export class GetTimerFavoritesCallBack extends Callback<Array<TimerFavorite>> {
	public constructor(private readonly setTimerFavorites: (payload: SetTimerFavoritesPayload) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<TimerFavorite>): void => {
		this.setTimerFavorites({
			timerFavorites: successResponse,
		});
	};
}
